import Vue from 'vue'
import { Loader } from 'google-maps'
import campFinderStep from '../views/campfinder-step.vue'
import campFinderCard from '../views/campfinder-card.vue'
import campFinderSelect from '../views/campfinder-select.vue'
import selectItem from '../views/campfinder-select-item.vue'
import campFinderInput from '../views/campfinder-input.vue'
export default {
    init() {
        new Vue({
            el: '#find-a-camp',
            components: {
                campFinderStep,
                campFinderCard,
                campFinderSelect,
                selectItem,
                campFinderInput,
            },
            data: {
                step01: {
                    question: null,
                    answer: null,
                },
                step02: {
                    question: null,
                    answer: null,
                },
                step03: {
                    question: null,
                    answer: null,
                },
                step04: {
                    question: null,
                    answer: null,
                },
                current: 1,
                finished: false,
                campsStaging: [],
                camps: [],
            },

            /* :: Mounted
            {+} ---------------------------------- */
            mounted() {
                this.$refs.progress.classList.remove('opacity-0')

                setTimeout(() => {
                    this.$refs.loader.classList.add('opacity-0', 'invisible')
                }, 600)
            },

            // π ----
            // :: METHODS ---------------------------::
            // ____
            methods: {
                /* :: PROCESSING STEP 01
                // :: Get Camps bases off of form selections
                {+} ---------------------------------- */
                getCamps() {
                    this.current = 'processing'
                    this.finished = true

                    $.ajax({
                        url: winshape.ajaxurl,
                        type: 'POST',
                        dataType: 'json',
                        data: {
                            action: 'CampFinder',
                            post_type: this.step03.answer,
                            gender: this.step01.answer,
                            grade: this.step02.answer,
                        },
                    })
                        .done(data => {
                            const camps = []

                            $.each(data.camps, function () {
                                const thisLatlng = this.coordinates.split(',')
                                const rawLat = thisLatlng[0]
                                const rawLng = thisLatlng[1]
                                const thisLat = parseFloat(rawLat.replace('(', ''))
                                const thisLng = parseFloat(rawLng)

                                const camp = {
                                    lat: thisLat,
                                    lng: thisLng,
                                    title: this.title,
                                    campType: this.camp_type,
                                    permalink: this.permalink,
                                    dates: this.dates,
                                    location: this.location,
                                    address: this.address,
                                    city: this.city,
                                    state: this.state,
                                    zip: this.zip,
                                }

                                camps.push([thisLat, thisLng, camp])
                            })

                            this.campsStaging = camps

                            this.locateUser(this.step04.answer)
                        })
                        .fail(() => {
                            console.log(`API request didn't load!`)
                        })
                },

                /* :: PROCESSING STEP 02
                // :: Generate lat/lng based on zip
                {+} ---------------------------------- */
                locateUser(zip) {
                    const loader = new Loader(winshape.maps_api, '')

                    loader.load().then(google => {
                        const geocoder = new google.maps.Geocoder()
                        const address = zip

                        geocoder.geocode(
                            {
                                address,
                            },
                            (results, status) => {
                                if (status == google.maps.GeocoderStatus.OK) {
                                    this.closestCamps(results[0].geometry.location)
                                } else {
                                    console.log(`The address you entered could not be verified. Please try again.`)
                                }
                            },
                        )
                    })
                },

                /* :: PROCESSING STEP 03
                // :: Return only closest camps
                {+} ---------------------------------- */
                closestCamps(userLocation) {
                    const userLat = userLocation.lat()
                    const userLon = userLocation.lng()
                    const userLatLon = [userLat, userLon]
                    const distances = []

                    function toRad(x) {
                        return (x * Math.PI) / 180
                    }

                    function distanceFromTo(user, location) {
                        const locLat = location[0]
                        const locLon = location[1]
                        const usrLat = user[0]
                        const usrLon = user[1]
                        const R = 3961
                        const x1 = usrLat - locLat
                        const dLat = toRad(x1)
                        const x2 = usrLon - locLon
                        const dLon = toRad(x2)

                        const a =
                            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                            Math.cos(toRad(locLat)) * Math.cos(toRad(usrLat)) * Math.sin(dLon / 2) * Math.sin(dLon / 2)

                        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
                        const d = R * c

                        return d
                    }

                    this.campsStaging.forEach((camp, index) => {
                        const thisDistance = distanceFromTo(userLatLon, camp)
                        distances.push([thisDistance, camp[2]])

                        return index >= 9 ? false : true
                    })

                    const sortedDistances = distances.sort((a, b) => a[0] - b[0])

                    this.camps = sortedDistances

                    setTimeout(() => {
                        this.current = 'results'
                    }, 1000)
                },

                progressSteps(step, type) {
                    let text
                    let background
                    let line
                    let parcel

                    function currentState(current, finished) {
                        if (current === step) {
                            text = 'text-white'
                            background = 'bg-red scale-120'
                        } else if (finished) {
                            text = 'text-grey-lighter'
                            background = 'bg-haze border-2 border-grey-lighter'
                            line = 'bg-grey-lighter'
                        } else if (current > step) {
                            text = 'text-white'
                            background = 'bg-pink'
                        } else {
                            text = 'text-red'
                            background = 'bg-white border-2 border-red'
                            line = 'bg-red'
                        }
                    }

                    function assetType() {
                        if (type === 'text') {
                            parcel = text
                        } else if (type === 'background') {
                            parcel = background
                        } else if (type === 'line') {
                            parcel = line
                        }
                    }

                    currentState(this.current, this.finished)
                    assetType()

                    return parcel
                },

                resetFinder() {
                    this.step01.answer = null
                    this.step02.answer = null
                    this.step03.answer = null
                    this.step04.answer = null
                    this.finished = false
                    this.current = 1
                },
            },
        })
    },
    finalize() {},
}
